<template>
  <div class="image-slider">
    <transition-group name="slide-right fade" class="transition-container" tag="div">
      <div v-for="i in [currentIndex]" :key="i" class="img-slide">
        <img :src="currentImg" />
      </div>
    </transition-group>
  </div>
</template>
<script>
export default {
  name: "ImageSlider",
  props: {
    images: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      timer: null,
      currentIndex: 0
    };
  },

  mounted: function() {
    this.startSlide();
  },

  methods: {
    startSlide: function() {
      this.timer = setInterval(this.next, 10000);
    },

    next: function() {
      this.currentIndex += 1;
    },
    prev: function() {
      this.currentIndex -= 1;
    }
  },

  computed: {
    currentImg: function() {
      return this.images[Math.abs(this.currentIndex) % this.images.length].image_desktop_filename;
    }
  }
};
</script>
<style>
.image-slider .fade-enter-active,
.image-slider .fade-leave-active {
  transition: all 0.9s ease;
  overflow: hidden;
  visibility: visible;
  position: absolute;
  width:100%;
  opacity: 1;
}

.image-slider .fade-enter,
.image-slider .fade-leave-to {
  visibility: hidden;
  width:100%;
  opacity: 0;
}

.image-slider img {
  width:100%
}
.image-slider .img-slide {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    max-height:542px;
    overflow:hidden;
}
.image-slider {
    width: 100%;
}

.image-slider .prev, .image-slider .next {
  cursor: pointer;
  position: absolute;
  top: 40%;
  width: auto;
  padding: 16px;
  color: white;
  font-weight: bold;
  font-size: 18px;
  transition: 0.7s ease;
  border-radius: 0 4px 4px 0;
  text-decoration: none;
  user-select: none;
}

.image-slider .next {
  right: 0;
}

.image-slider .prev {
  left: 0;
}

.image-slider .prev:hover, .image-slider .next:hover {
  background-color: rgba(0,0,0,0.9);
}




.image-slider .slide-right-enter-active,
.image-slider .slide-right-leave-active,
.image-slider .slide-left-enter-active,
.image-slider .slide-left-leave-active{
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.image-slider .slide-left-enter {
  transform: translateX(100%);
}

.image-slider .slide-left-leave-to {
   transform: translateX(-100%);
}

.image-slider .slide-right-enter {
  transform: translateX(-100%);
}

.image-slider .slide-right-leave-to {
   transform: translateX(100%);
}
</style>


// WEBPACK FOOTER //
// src/components/shared/ImageSlider.vue